export default {
  variant: {
    primary: {
      light: 'color.lightBlue',
      base: 'color.blue',
      dark: 'color.darkBlue',
      text: 'color.white',
    },
    secondary: {
      light: 'color.gray60',
      base: 'color.gray70',
      dark: 'color.gray90',
      text: 'color.gray20',
    },
    error: {
      light: 'color.lightRed',
      base: 'color.red',
      dark: 'color.darkRed',
      text: 'color.white',
    },
    background: {
      light: 'color.gray20', // remove
      base: 'color.gray90',
      dark: 'color.gray50',
      text: 'color.gray70',
    },
    surface: {
      light: 'color.gray00', //remove
      base: 'color.gray80',
      dark: 'color.gray20',
      text: 'color.gray80',
    },
  },
  palette: {
    primary: '#8ee8ff',
    error: '#ff5959',
    errorAlt: '#ff5959',
    success: '#9affa6',
    successAlt: '#59ff67',
    warning: '#ffa359',
    warningAlt: '#ffa359',
    background: '#191d23',
    backgroundAlt: '#000000',
    surface: '#262c35',
    surfaceAlt: '#111419',
    secondary: '#3e4751',
    secondaryAlt: '#5A616A',
    contrastHigh: '#ffffff',
    contrastLow: '#c6d1db',
    contrastInvert: '#000000',
    code: {
      accent1: '#ff9ae1',
      accent2: '#9affa6',
      accent3: '#8ee8ff',
      accent4: '#c6d1db',
      accent5: '#c792ea',
      accent6: '#ffa359',
      accent7: '#9affe1',
      accent8: '#f2ff00',
      accent9: '#ff5959',
    },
  },
};
